module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"_","amd":"underscore","commonjs":"underscore","commonjs2":"underscore"}
 ** module id = 5
 ** module chunks = 0
 **/